/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage } from 'premier-capability-policyjob-react';

import InfoPage from './pages/Info/InfoPage';
import QuestionsPage from './pages/Questions/QuestionsPage';
import ExposuresPage from './pages/Exposures/ExposuresPage';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import ArchitectEngineerPage from './pages/ArchitectEngineer/ArchitectEngineerPage';
import MiscellaneousPage from './pages/Miscellaneous/MiscellaneousPage';
import AccountantPage from './pages/Accountant/AccountantPage';
import ITProfessionalPage from './pages/ITProfessional/ITProfessionalPage';
import LifeAgentsPage from './pages/LifeAgents/LifeAgentsPage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import MedicalPractitionersPage from './pages/MedicalPractitioners/MedicalPractitionersPage';
import PropertyPage from './pages/Property/PropertyPage';
import PropertyCoveragesPage from './pages/PropertyCoverages/PropertyCoveragesPage';
import CoverablesPage from './pages/Coverables/CoverablesPage';
import SingleCoverablePage from './pages/Coverables/SingleCoverablePage';
import QuotePage from './pages/Quote/QuotePage';
import DirAndOffLiabilityPage from './pages/DirAndOffLiability/DirAndOffLiabilityPage';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';

setComponentMapOverrides(
    {
        // wizard pages
        PremierPLPolicyDetailsPage: { component: 'PremierPLPolicyDetailsPage' },
        PremierPLDeclarationPage: { component: 'PremierPLDeclarationPage' },
        PremierPLOfferingsPage : { component: 'PremierPLOfferingsPage'},
        PremierPLLocationsPage : { component: 'PremierPLLocationsPage'},
        PremierPLInfoPage: { component: 'PremierPLInfoPage' },
        PremierPLQuestionsPage: { component: 'PremierPLQuestionsPage' },
        PremierPLSingleCoverablePage: { component: 'PremierPLSingleCoverablePage' },
        PremierPLExposuresPage: { component: 'PremierPLExposuresPage' },
        PremierPLCoveragesPage: { component: 'PremierPLCoveragesPage' },
        PremierPLArchitectEngineerPage: { component: 'PremierPLArchitectEngineerPage' },
        PremierPLMiscellaneousPage: { component: 'PremierPLMiscellaneousPage' },
        PremierPLAccountantPage: { component: 'PremierPLAccountantPage' },
        PremierPLITProfessionalPage : { component: 'PremierPLITProfessionalPage' },
        PremierPLLifeAgentsPage : { component: 'PremierPLLifeAgentsPage' },
        PremierPLPropertyPage: { component: 'PremierPLPropertyPage' },
        PremierPLPropertyCoveragesPage: { component: 'PremierPLPropertyCoveragesPage' },
        PremierPLLiabilityCoveragesPage: { component: 'PremierPLLiabilityCoveragesPage' },
        PremierPLCoverablesPage: { component: 'PremierPLCoverablesPage' },
        PremierPLRiskAnalysisPage: { component: 'PremierPLRiskAnalysisPage' },
        PremierPLQuotePage: { component: 'PremierPLQuotePage' },
        PremierPLPolicyInfoPage: { component: 'PremierPLPolicyInfoPage' },
        PremierPLPaymentDetailsPage: { component: 'PremierPLPaymentDetailsPage' },
        PremierPLSuccessPage: { component: 'PremierPLSuccessPage' },
		PremierPLMedicalPractitionersProfessionalPage : {component: 'PremierPLMedicalPractitionersProfessionalPage'},
        PremierPLDirectorsAndOfficersProfessionalPage : { component: 'PremierPLDirectorsAndOfficersProfessionalPage' },
    },
    {
        // wizard pages
        PremierPLPolicyDetailsPage: PolicyDetailsPage,
        PremierPLDeclarationPage: DeclarationPage,
        PremierPLOfferingsPage: OfferingsPage,
        PremierPLLocationsPage: LocationsPage,
        PremierPLInfoPage: InfoPage,
        PremierPLQuestionsPage: QuestionsPage,
        PremierPLSingleCoverablePage: SingleCoverablePage,
        PremierPLArchitectEngineerPage: ArchitectEngineerPage,
        PremierPLMiscellaneousPage: MiscellaneousPage,
		PremierPLMedicalPractitionersProfessionalPage: MedicalPractitionersPage,
        PremierPLAccountantPage: AccountantPage,
        PremierPLITProfessionalPage: ITProfessionalPage,
        PremierPLLifeAgentsPage: LifeAgentsPage,
        PremierPLPropertyPage: PropertyPage,
        PremierPLPropertyCoveragesPage: PropertyCoveragesPage,
        PremierPLLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierPLExposuresPage: ExposuresPage,
        PremierPLCoveragesPage: CoveragesPage,
        PremierPLCoverablesPage: CoverablesPage,
        PremierPLRiskAnalysisPage: RiskAnalysisPage,
        PremierPLQuotePage: QuotePage,
        PremierPLPolicyInfoPage: PolicyInfoPage,
        PremierPLPaymentDetailsPage: PaymentDetailsPage,
        PremierPLSuccessPage: SuccessPage,
        PremierPLDirectorsAndOfficersProfessionalPage: DirAndOffLiabilityPage
    }
);

export { CodegenWizard, CodegenContext };
